/**
 * Pantallas de sesión compartidas: Entra sin configurar y error de `/me`.
 *
 * Las usan `HomeView` (ruta `/`) y `TierGate` (rutas con acceso por tier).
 * El login vive en `./LoginScreen`, la única pantalla de inicio de sesión
 * (`loginRedirect` de MSAL), compartida también con las vistas de agentes.
 */

import { useTranslation } from 'react-i18next'

import { ApiError } from '../api/client'

export function MsalNotConfigured() {
  const { t } = useTranslation('auth')
  return (
    <div className="h-full overflow-y-auto grid place-items-center px-6 py-16">
      <section className="w-full max-w-lg rounded-md border border-review/40 bg-surface p-6">
        <h2 className="font-display text-xl text-ink">{t('login.title')}</h2>
        <p className="mt-2 font-body text-sm text-ink-muted">
          {t('login.msal_not_configured', {
            env_var: 'VITE_ENTRA_*',
            file: '.env',
            cmd: 'npm run dev',
          })}
        </p>
      </section>
    </div>
  )
}

export function MeError({ error }: { error: unknown }) {
  const { t } = useTranslation(['auth', 'errors'])
  const message = humanizeError(error, t)
  return (
    <div className="rounded-md border border-critical/40 bg-critical-soft p-4 max-w-3xl">
      <h3 className="font-display text-sm uppercase tracking-wide text-critical">
        {t('auth:me.error_title')}
      </h3>
      <pre className="mt-2 whitespace-pre-wrap font-mono text-xs text-critical">
        {message}
      </pre>
    </div>
  )
}

function humanizeError(
  err: unknown,
  t: ReturnType<typeof useTranslation>['t'],
): string {
  if (err instanceof ApiError) {
    return t(`errors:${err.code}` as const, {
      defaultValue: err.body?.message ?? err.message,
    })
  }
  if (err instanceof Error) return err.message
  return 'unknown'
}
